export const userConstants = {
    USER_FETCHING: 'USER_FETCHING',
    USER_FETCHED: 'USER_FETCHED',
    USER_SUBMITTING: 'USER_SUBMITTING',
    USER_SUBMITTED: 'USER_SUBMITTED',
    GET_USERS: 'GET_USERS',
    GET_USER_BY_ID: 'GET_USER_BY_ID',
    GET_USER_BY_ID_LOGIN: 'GET_USER_BY_ID_LOGIN',
    SETUP_USER: 'SETUP_USER',
    LOGIN_USER_SUCCESS: 'LOGIN_USER_SUCCESS',
    LOGIN_USER_FAIL: 'LOGIN_USER_FAIL',
    CHANGE_PASSWORD: 'CHANGE_PASSWORD',
    CURRENT_VERSION: 'CURRENT_VERSION',
    ALLOW_LEAVE_PAGE: 'ALLOW_LEAVE_PAGE',
    NOT_ALLOW_LEAVE_PAGE: 'NOT_ALLOW_LEAVE_PAGE',
    CHANGE_PASSWORD_ADMIN: 'CHANGE_PASSWORD_ADMIN',
}